
import Vue from 'vue';
import moment from 'moment';
import Button from '@/components/Button/index.vue';
import Select from '@/components/Select/index.vue';
import { createPayment, CreatePaymentParams } from '@/services/payments/create-payments';
import { getTicket } from '@/services/ticket/get-ticket';
import { generateLinkGix, GenerateLinkGixParams } from '@/services/gix/generate-link-gix';
import { GetAddressUserParams, getAddressUser } from '@/services/user/get-address-user';
import { TableHeader } from '@/utils';
import Table from '@/components/TableCustom/index.vue';
import { divAlert } from './styles';

moment.locale('pt-br');
const ticketStatus = {
  pending: 'Pendente',
  payed: 'Pago',
  cancelled: 'Cancelado',
};
export default Vue.extend({
  components: {
    Select,
    Button,
    divAlert,
    Table,
  },
  inject: [
    'userLogged',
    'resetStepsRegisterTerritory',
    'getStepDate',
    'changeStatusTerritoryCarRequest',
  ],
  data() {
    return {
      headers: [
        {
          key: 'ticketName',
          value: 'Boletos',
          hideOrder: true,
          order: false,
        },
        {
          key: 'dueDate',
          value: 'Data de vencimento',
          hideOrder: true,
          order: false,
        },
        {
          key: 'status',
          value: 'Status',
          tag: true,
          order: false,
          hideOrder: true,
        },
        {
          key: 'urlFile',
          value: 'Download',
          link: true,
          hideOrder: true,
        },
      ] as TableHeader[],
      modalAddAgent: true,
      isErrorHiddenMessage: true,
      isLoading: false,
      penaltyValueTotal: '',
      Iteminstallments: 0,
      totalInstallment: '',
      contitionBool: false,
      agentId: '',
      addressObj: {} as any,
      convention: {
        numeroConvenio: 3128557,
      },
      userLoged: JSON.parse(sessionStorage.getItem('userLogged') as string),
    };
  },
  computed: {
    getData(): any[] {
      return this.getStepDate.tickets.map((data) => ({
        ...data,
        status: ticketStatus[data.status],
        dueDate: moment(data.dueDate).format('L'),
        ticketName: moment(data.dueDate).format('MMMM'),
      }));
    },
    formatInstallments(): string[] {
      // @ts-ignore
      return Array.from({ length: this.$route.params.installments }, (_, index) => {
        const current = index + 1;
        const penaltyValueInstallments = this.formatNumber(
          // @ts-ignore
          this.$route.params.paymentValue / current,
        );
        return `${current}x sem juros de ${penaltyValueInstallments}`;
      });
    },
  },
  methods: {
    formatNumber(value: number) {
      return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    },
    onHiddenMessage() {
      if (!this.$route.params.installments) {
        this.isErrorHiddenMessage = false;
        return;
      }
      this.isErrorHiddenMessage = true;
    },
    async onNextStepSix() {
      this.contitionBool = true;
      try {
        this.isLoading = true;
        await this.createPaymentRequest();
        this.changeStatusTerritoryCarRequest('PROVISORIO');
        this.getTicketRequest();
        this.getGenerateGixLinkRequest();
        this.getStepDate.currentStep += 1;
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        this.resetStepsRegisterTerritory();
        this.getStepDate.isErrors = true;
      }
    },
    onSelectInput(_: string, index: number) {
      this.Iteminstallments = index;
    },
    async createPaymentRequest() {
      const paramsItem: GetAddressUserParams = {
        tokenKey: this.userLogged.company.stKey,
        cdUser: this.userLogged.idUser,
      };
      getAddressUser(paramsItem).then((data) => {
        this.addressObj = { ...this.addressObj, ...data };
      });
      const stDocument = '71943984190';
      const params: CreatePaymentParams = {
        name: 'VALERIO ALVES BARROS', // TODO add "stName"
        numInscricao: stDocument, // TODO add "stDocument"
        address: this.addressObj.address,
        number: this.addressObj.number,
        cep: this.addressObj.zipCode.replaceAll('-', ''),
        city: this.addressObj.city,
        neighboor: this.addressObj.neighborhood,
        uf: this.addressObj.state,
        telephone: '4135643413',
        initialInstallmentToProcess: 1,
        quantityOfInstallmentsToProcess: this.Iteminstallments,
        totalInstallment: +this.Iteminstallments,
        totalPenaltyDue: parseInt(this.$route.params.paymentValue, 10),
        cdTerritory: this.$route.params.id,
      };
      // await deleteTickets(,this.userLoged.company.stKey);
      const response = await createPayment(params);

      if (response?.hasErrors) {
        this.getStepDate.isErrors = true;
      } else {
        Vue.swal('', 'Multa atualizada com sucesso', 'success');
      }
    },
    getTicketRequest() {
      const loader = this.$loading.show({
        container: this.$refs.loadingContainer,
      });

      getTicket(this.$route.params.id)
        .then((data) => {
          loader.hide();
          this.getStepDate.tickets = data;
          this.getStepDate.isLoadingPayment = false;
        })
        .catch(() => {
          this.resetStepsRegisterTerritory();
          this.getStepDate.isErrors = true;
        });
    },
    getGenerateGixLinkRequest() {
      const params: GenerateLinkGixParams = {
        TokenKey: this.userLogged.company.stKey,
        NameTerritory: this.getStepDate.territory.name,
        CdUser: this.userLogged.idUser,
        CdTerritory: this.getStepDate.territory.id,
        CdJourneyModel: 1,
        CdJourneyGroupModel: 1,
        CdJourneyGroupTaskModel: [1, 2, 3, 4],
      };

      generateLinkGix(params).then((data) => {
        this.getStepDate.gixUrl = data;
      });
    },
  },
  created() {
    this.getTicketRequest();
  },
});
